import React, { useState, useEffect } from 'react';
import PropTypes from 'prop-types';
import DefaultTextField from 'components/Utils/DefaultTextField';
import DefaultButton from 'components/Utils/NewDefaultButton';
import CPPUtils from 'services/CPPUtils';
import { useAppSelector } from 'careand-redux/store';

const BMICalculatorModal = ({ patient, onSubmit }) => {
  const patientHr = useAppSelector((state) => state.healthRecords.byId[patient?.id]);
  const measurements = CPPUtils.getPatientMeasurements(patientHr);

  const [height, setHeight] = useState('');
  const [weight, setWeight] = useState('');

  useEffect(() => {
    if (measurements.height) setHeight('' + measurements.height);
    if (measurements.weight) setWeight('' + measurements.weight);
  }, [measurements.height, measurements.weight]);

  const bmi = CPPUtils.calculateBMI(parseFloat(height), parseFloat(weight));
  const category = getCategory(bmi);
  const resultText = bmi ? `${bmi} (${category})` : 'N/A';
  const buttonEnabled = !!bmi;

  function getCategory(bmi) {
    if (!bmi) return '';
    const value = parseFloat(bmi);
    if (value < 18.5) return 'Underweight';
    if (value < 25) return 'Normal';
    if (value < 30) return 'Overweight';
    return 'Obese';
  }

  function copyToClipboard() {
    navigator.clipboard.writeText(`BMI: ${resultText}`);
  }

  return (
    <div className="modal h-full" style={{ width: '300px' }}>
      <div className="title">BMI Calculator</div>
      <div className="padded-box" style={{ display: 'flex', flexDirection: 'column', gap: '10px' }}>
        <DefaultTextField
          name="height"
          label="Height (cm)"
          value={height}
          onChange={(event) => setHeight(event.target.value)}
        />
        <DefaultTextField
          name="weight"
          label="Weight (kg)"
          value={weight}
          onChange={(event) => setWeight(event.target.value)}
        />
        <DefaultTextField name="result" label="BMI" value={resultText} disabled={true} />
        {!!onSubmit && (
          <DefaultButton
            name="Submit"
            onClick={() => onSubmit(resultText)}
            style={{ width: '100%' }}
            disabled={!buttonEnabled}
          />
        )}
        {!onSubmit && (
          <DefaultButton
            name="Copy to Clipboard"
            onClick={copyToClipboard}
            style={{ width: '100%' }}
            disabled={!buttonEnabled}
          />
        )}
      </div>
    </div>
  );
};

BMICalculatorModal.propTypes = {
  patient: PropTypes.object,
  onSubmit: PropTypes.func,
};

export default BMICalculatorModal;
